module.exports = __webpack_public_path__ + "static/media/bolon-scope.3bc9551f.png";